//const urlPath = "http://mjuserver-env-1.eba-5gquipwn.ap-southeast-1.elasticbeanstalk.com"/*deploy*/
//const urlPath = "https://mju-server.herokuapp.com"/*heroku*/
const urlPath = "https://organiclesson-api.mju.ac.th"/*testing*/
// const urlPath = "https://mju-api.undefined.co.th:4439"/*testing*/
// const urlPath = "http://localhost:3001"/*testing*/
export default urlPath;